module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("Feasting and Fasting")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("The History and Ethics of Jewish Food")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Edited by Aaron S. Gross, Jody Myers, and Jordan D. Rosenblum")]), _vm._v(" "), _c('p', {
    staticClass: "bkau1"
  }, [_vm._v("With a Foreword by Hasia R. Diner and an Afterword by Jonathan Safran Foer")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "50",
      "src": "images/nyu-logo.jpg",
      "width": "42"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("New York")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f197451","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nyugross0002.vue
// module id = 57
// module chunks = 0